export default "__VITE_ASSET__pa3dwF3m__"